/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import Slider from 'react-input-slider';
import HighSchoolIcon from '../HighSchoolIcon';
import AdultLearnerIcon from '../AdultLearnerIcon';
import AssociateDegreeIcon from '../AssociateDegreeIcon';
import SomeGraduateIcon from '../SomeGraduateIcon';
import MastersDegreeIcon from '../MastersDegreeIcon';
import DoctorateDegreeIcon from '../DoctorateDegreeIcon';
import HSDiplomaIcon from '../HSDiplomaIcon';
import SomeCollegeIcon from '../SomeCollegeIcon';
import BachelorsDegreeIcon from '../BachelorsDegreeIcon';

export default function EducationSlider({
  tenant,
  educationLevelDiff,
  sliderPercent,
  checkSliderChange,
  handleIconKeyDown,
}) {
  const sliderStyles = {
    track: {
      backgroundColor: '#EFEFEF',
      width: '100%',
      display: 'flex',
      height: '8px',
      opacity: 0.8,
    },
    active: {
      backgroundColor: tenant.primary,
    },
    thumb: {
      width: 30,
      height: 30,
      border: `2px solid ${tenant.primary}`,
      color: '#FFFFFF',
      boxShadow: '0px 2px 10px #00000046',
    },
    disabled: {
      opacity: 0.2,
    },
  };

  const pipPoints = [10, 20, 30, 40, 50, 60, 70, 80, 90];

  const renderPips = () => {
    const pipsMap = pipPoints.map((pip) => {
      const isHidden = sliderPercent >= pip ? 'hidden' : 'visible';
      const pipStyle = {
        visibility: isHidden,
      };

      return <div key={pip} className="pip" style={pipStyle} />;
    });

    return <div className="pip-container">{pipsMap}</div>;
  };

  return (
    <div className="slider-pips-icons-container" role="presentation">
      <div className="slider-pips-container">
        {renderPips()}
        <div className="slider-only-container">
          <Slider
            axis="x"
            xstep={educationLevelDiff}
            xmin={0}
            xmax={100}
            styles={sliderStyles}
            x={sliderPercent}
            onChange={({ x }) => checkSliderChange(x)}
          />
        </div>
      </div>
      <div className="education-icons-container">
        <div className="education-icon-slider">
          <figure
            role="button"
            className="education-icon"
            onClick={() => checkSliderChange(10)}
            onKeyDown={(e) => handleIconKeyDown(e, 10)}
            tabIndex={0}
            aria-label="select Currently in high school"
          >
            <HighSchoolIcon
              color={tenant.secondary}
              height="40px"
              width="40px"
            />
          </figure>
          <figure
            role="button"
            className="alt-circle"
            onClick={() => checkSliderChange(10)}
            onKeyDown={(e) => handleIconKeyDown(e, 10)}
            tabIndex={0}
            aria-label="select Currently in high school"
          >
            <svg height="10" width="10">
              <circle cx="5" cy="5" r="4" fill={tenant.secondary} />
            </svg>
          </figure>
        </div>
        <div className="education-icon-slider">
          <figure
            role="button"
            className="education-icon "
            onClick={() => checkSliderChange(20)}
            onKeyDown={(e) => handleIconKeyDown(e, 20)}
            tabIndex={0}
            aria-label="select Adult learner, no HS diploma or GED"
          >
            <AdultLearnerIcon
              color={tenant.secondary}
              height="40px"
              width="40px"
            />
          </figure>
          <figure
            role="button"
            className="alt-circle "
            onClick={() => checkSliderChange(20)}
            onKeyDown={(e) => handleIconKeyDown(e, 20)}
            tabIndex={0}
            aria-label="select Adult learner, no HS diploma or GED"
          >
            <svg height="10" width="10">
              <circle cx="5" cy="5" r="4" fill={tenant.secondary} />
            </svg>
          </figure>
        </div>
        <div className="education-icon-slider">
          <figure
            role="button"
            className="education-icon"
            onClick={() => checkSliderChange(30)}
            onKeyDown={(e) => handleIconKeyDown(e, 30)}
            tabIndex={0}
            aria-label="select Have high school diploma or GED"
          >
            <HSDiplomaIcon
              color={tenant.secondary}
              height="40px"
              width="40px"
            />
          </figure>
          <figure
            role="button"
            className="alt-circle "
            onClick={() => checkSliderChange(30)}
            onKeyDown={(e) => handleIconKeyDown(e, 30)}
            tabIndex={0}
            aria-label="select Have high school diploma or GED"
          >
            <svg height="10" width="10">
              <circle cx="5" cy="5" r="4" fill={tenant.secondary} />
            </svg>
          </figure>
        </div>
        <div className="education-icon-slider">
          <figure
            role="button"
            className="education-icon"
            onClick={() => checkSliderChange(40)}
            onKeyDown={(e) => handleIconKeyDown(e, 40)}
            tabIndex={0}
            aria-label="select Some college courses"
          >
            <SomeCollegeIcon
              color={tenant.secondary}
              height="40px"
              width="40px"
            />
          </figure>
          <figure
            role="button"
            className="alt-circle "
            onClick={() => checkSliderChange(40)}
            onKeyDown={(e) => handleIconKeyDown(e, 40)}
            tabIndex={0}
            aria-label="select Some college courses"
          >
            <svg height="10" width="10">
              <circle cx="5" cy="5" r="4" fill={tenant.secondary} />
            </svg>
          </figure>
        </div>
        <div className="education-icon-slider">
          <figure
            role="button"
            className="education-icon "
            onClick={() => checkSliderChange(50)}
            onKeyDown={(e) => handleIconKeyDown(e, 50)}
            tabIndex={0}
            aria-label="select Associate degree"
          >
            <AssociateDegreeIcon
              color={tenant.secondary}
              height="40px"
              width="40px"
            />
          </figure>
          <figure
            role="button"
            className="alt-circle "
            onClick={() => checkSliderChange(50)}
            onKeyDown={(e) => handleIconKeyDown(e, 50)}
            tabIndex={0}
            aria-label="select Associate degree"
          >
            <svg height="10" width="10">
              <circle cx="5" cy="5" r="4" fill={tenant.secondary} />
            </svg>
          </figure>
        </div>
        <div className="education-icon-slider">
          <figure
            role="button"
            className="education-icon "
            onClick={() => checkSliderChange(60)}
            onKeyDown={(e) => handleIconKeyDown(e, 60)}
            tabIndex={0}
            aria-label="select Bachelor’s degree"
          >
            <BachelorsDegreeIcon
              color={tenant.secondary}
              height="40px"
              width="40px"
            />
          </figure>
          <figure
            role="button"
            className="alt-circle "
            onClick={() => checkSliderChange(60)}
            onKeyDown={(e) => handleIconKeyDown(e, 60)}
            tabIndex={0}
            aria-label="select Bachelor’s degree"
          >
            <svg height="10" width="10">
              <circle cx="5" cy="5" r="4" fill={tenant.secondary} />
            </svg>
          </figure>
        </div>
        <div className="education-icon-slider">
          <figure
            role="button"
            className="education-icon "
            onClick={() => checkSliderChange(70)}
            onKeyDown={(e) => handleIconKeyDown(e, 70)}
            tabIndex={0}
            aria-label="select Some graduate courses"
          >
            <SomeGraduateIcon
              color={tenant.secondary}
              height="40px"
              width="40px"
            />
          </figure>
          <figure
            role="button"
            className="alt-circle "
            onClick={() => checkSliderChange(70)}
            onKeyDown={(e) => handleIconKeyDown(e, 70)}
            tabIndex={0}
            aria-label="select Some graduate courses"
          >
            <svg height="10" width="10">
              <circle cx="5" cy="5" r="4" fill={tenant.secondary} />
            </svg>
          </figure>
        </div>
        <div className="education-icon-slider">
          <figure
            role="button"
            className="education-icon "
            onClick={() => checkSliderChange(80)}
            onKeyDown={(e) => handleIconKeyDown(e, 80)}
            tabIndex={0}
            aria-label="select Master's degree or two-year graduate credential"
          >
            <MastersDegreeIcon
              color={tenant.secondary}
              height="40px"
              width="40px"
            />
          </figure>
          <figure
            role="button"
            className="alt-circle "
            onClick={() => checkSliderChange(80)}
            onKeyDown={(e) => handleIconKeyDown(e, 80)}
            tabIndex={0}
            aria-label="select Master's degree or two-year graduate credential"
          >
            <svg height="10" width="10">
              <circle cx="5" cy="5" r="4" fill={tenant.secondary} />
            </svg>
          </figure>
        </div>
        <div className="education-icon-slider">
          <figure
            role="button"
            className="education-icon "
            onClick={() => checkSliderChange(90)}
            onKeyDown={(e) => handleIconKeyDown(e, 90)}
            tabIndex={0}
            aria-label="select Doctorate degree or four-year graduate credential"
          >
            <DoctorateDegreeIcon
              color={tenant.secondary}
              height="40px"
              width="40px"
            />
          </figure>
          <figure
            role="button"
            className="alt-circle "
            onClick={() => checkSliderChange(90)}
            onKeyDown={(e) => handleIconKeyDown(e, 90)}
            tabIndex={0}
            aria-label="select Doctorate degree or four-year graduate credential"
          >
            <svg height="10" width="10">
              <circle cx="5" cy="5" r="4" fill={tenant.secondary} />
            </svg>
          </figure>
        </div>
      </div>
    </div>
  );
}
